import { useEffect, useState } from "react";

import { PAYMENT_REQUIRED_EVENT } from "../helpers";
import ModalPaymentRequired from "./modals/ModalPaymentRequired";

const PaymentRequiredHandler = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const showPaymentRequiredModal = () => setIsOpen(true);

    window.addEventListener(PAYMENT_REQUIRED_EVENT, showPaymentRequiredModal);
    return () => {
      window.removeEventListener(
        PAYMENT_REQUIRED_EVENT,
        showPaymentRequiredModal
      );
    };
  }, []);

  const dismissPaymentRequiredModal = () => {
    setIsOpen(false);
    window.location.assign("/login");
  };

  return (
    <ModalPaymentRequired
      onDismiss={dismissPaymentRequiredModal}
      open={isOpen}
    />
  );
};

export default PaymentRequiredHandler;
